import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  serviceGetSubsriptionList,
} from "../../../services/Reward.service";
import {serviceGetSideEffects} from "../../../services/ReportedSideEffects.service";

const useAppUsersDetailHook = () => {
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [programData, setProgramData] = useState([]);
  const [sideEffectsData, setSideEffcetsData] = useState([]);
  const location = useLocation();

  const appUserDetails = useMemo(
    () => location?.state?.appusers || null,
    [location?.state?.appusers]
  );

  useEffect(() => {
    if (id) {
      serviceGetSubsriptionList({
        user_id: id,
      }).then((res) => {
        if (!res.error) {
          const resData = res?.data || [];
          setProgramData(resData);
        }
      });
    }
  }, [id]);

  // useEffect(() => {
  //   if (id) {
  //     serviceGetSideEffects({
  //       user_id: id,
  //     }).then((res) => {
  //       if (!res.error) {
  //         const resData = res?.data || [];
  //         setSideEffcetsData(resData);
  //       }
  //     });
  //   }
  // }, [id]);

  const handleChange = useCallback((event, newValue) => {
    setValue(newValue);
  }, []);

  return {
    value,
    handleChange,
    appUserDetails,
    programData,
    sideEffectsData,
  };
};

export default useAppUsersDetailHook;
